import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';

gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    init: function() {
      document.querySelectorAll( '[data-component="pattern-hero"]' ).forEach( ( component ) => {
        const pattern = component.querySelector( '.pattern-hero__pattern' );
        if ( !pattern ) {
          return;
        }

        if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
          gsap.set( pattern, {autoAlpha: 0.2, y: 0} );
          return;
        }

        gsap.set( pattern, {autoAlpha: 0, y: -100} );

        gsap.to( pattern, {
          autoAlpha: 0.2,
          y: 0,
          duration: 0.75,
          delay: 0.7,
          ease: 'power2.out',
          clearProps: 'transform,visibility',
          scrollTrigger: {
            trigger: component,
            start: 'top 85%',
            once: true,
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'pattern-hero', COMPONENT );
} )( app );
